"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onInitializationError = exports.onInitialization = exports.onFailMaxRetries = exports.onFailNoRetry = exports.onRetry = exports.onPostMessageUrlValidated = exports.onSendReferralData = exports.onSendBookingData = exports.onRemoveReferral = exports.onAddReferral = exports.onPatientReceived = exports.captureEnvData = exports.dismissError = exports.setError = exports.validatePatientForBooking = exports.validatePatientForReferral = exports.updatePostMessageUrl = exports.clearReferrals = exports.setPatientInContext = exports.removeReferral = exports.addReferral = exports.incrementRetriesSendingBookingData = exports.incrementRetriesSendingReferralData = exports.incrementRetriesRequestPatient = exports.NOOP = void 0;
const provider_components_1 = require("@kyruus/provider-components");
const xstate_1 = require("xstate");
const util_1 = require("../common/util");
const constants_1 = require("../common/constants");
const types_1 = require("../types");
/**
 * A function that results in no operation.
 */
const NOOP = () => {
    /* No-op */
};
exports.NOOP = NOOP;
exports.incrementRetriesRequestPatient = (0, xstate_1.assign)({
    retries: (ctx) => (Object.assign(Object.assign({}, ctx.retries), { requestPatient: ctx.retries.requestPatient + 1 }))
});
exports.incrementRetriesSendingReferralData = (0, xstate_1.assign)({
    retries: (ctx) => (Object.assign(Object.assign({}, ctx.retries), { sendReferralData: ctx.retries.sendReferralData + 1 }))
});
exports.incrementRetriesSendingBookingData = (0, xstate_1.assign)({
    retries: (ctx) => (Object.assign(Object.assign({}, ctx.retries), { sendBookingData: ctx.retries.sendBookingData + 1 }))
});
exports.addReferral = (0, xstate_1.assign)({
    referrals: (ctx, ev) => {
        (0, util_1.assertEventType)(ev, constants_1.CrmConnectorEvents.ADD_REFERRAL);
        const referredProvider = ev.data;
        const { referrals } = ctx;
        const providerIdx = referrals.findIndex(({ provider, location }) => provider.id === referredProvider.provider.id &&
            (location === null || location === void 0 ? void 0 : location.id) === referredProvider.location.id);
        if (providerIdx === -1) {
            return [
                ...referrals,
                Object.assign(Object.assign({}, referredProvider), { status: provider_components_1.ProviderStatus.REFERRED })
            ];
        }
        return referrals;
    }
});
exports.removeReferral = (0, xstate_1.assign)({
    referrals: (ctx, ev) => {
        (0, util_1.assertEventType)(ev, constants_1.CrmConnectorEvents.REMOVE_REFERRAL);
        const referredProvider = ev.data;
        const { referrals } = ctx;
        const providerIdx = referrals.findIndex(({ provider, location }) => provider.id === referredProvider.provider.id &&
            (location === null || location === void 0 ? void 0 : location.id) === referredProvider.location.id);
        if (providerIdx === -1) {
            return referrals;
        }
        return [
            ...referrals.slice(0, providerIdx),
            ...referrals.slice(providerIdx + 1)
        ];
    }
});
exports.setPatientInContext = (0, xstate_1.assign)({
    patient: (ctx, ev) => {
        (0, util_1.assertEventType)(ev, constants_1.CrmConnectorEvents.PATIENT_RECEIVED);
        if (!ev.data) {
            return ctx.patient;
        }
        const _a = ev.data, { caseId: _caseId } = _a, restOfTheData = __rest(_a, ["caseId"]);
        return restOfTheData;
    },
    id: (ctx, ev) => {
        (0, util_1.assertEventType)(ev, constants_1.CrmConnectorEvents.PATIENT_RECEIVED);
        if (!ev.data) {
            return ctx.id;
        }
        const { caseId } = ev.data;
        return caseId;
    }
});
exports.clearReferrals = (0, xstate_1.assign)({
    referrals: (_, ev) => {
        (0, util_1.assertEventType)(ev, constants_1.CrmConnectorEvents.DONE_INVOKE_SEND_REFERRAL_DATA);
        return [];
    }
});
exports.updatePostMessageUrl = (0, xstate_1.assign)({
    postMessageUrl: (_, ev) => {
        (0, util_1.assertEventType)(ev, constants_1.CrmConnectorEvents.DONE_INVOKE_VALIDATE_POST_MESSAGE);
        return ev.data;
    }
});
const validatePatient = ({ patient, requiredFields, requiredAddressFields }) => {
    const invalidFields = [];
    if (patient) {
        requiredFields.forEach((requiredField) => {
            if (!patient[requiredField]) {
                invalidFields.push(requiredField);
            }
            else {
                if (requiredField === 'address') {
                    requiredAddressFields.forEach((addressField) => {
                        if (patient.address &&
                            (!patient.address[addressField] ||
                                patient.address[addressField] === '')) {
                            invalidFields.push(addressField);
                        }
                    });
                }
                else if (patient[requiredField] === '') {
                    invalidFields.push(requiredField);
                }
            }
        });
    }
    return invalidFields;
};
exports.validatePatientForReferral = (0, xstate_1.assign)((ctx) => {
    const patient = ctx.patient;
    const invalidFields = validatePatient({
        patient,
        requiredFields: constants_1.REQUIRED_PATIENT_FIELDS.referral,
        requiredAddressFields: constants_1.REQUIRED_PATIENT_ADDRESS_FIELDS.referral
    });
    if (invalidFields.length > 0) {
        const referralValidationError = {
            message: 'Invalid Patient Error - Referral',
            displayToUser: true,
            type: types_1.ValidationErrorType.INVALID_PATIENT_DATA_REFERRAL,
            data: invalidFields
        };
        return Object.assign(Object.assign({}, ctx), { validationErrors: Object.assign(Object.assign({}, ctx.validationErrors), { referral: referralValidationError }) });
    }
    return ctx;
});
exports.validatePatientForBooking = (0, xstate_1.assign)((ctx) => {
    const patient = ctx.patient;
    const invalidFields = validatePatient({
        patient,
        requiredFields: constants_1.REQUIRED_PATIENT_FIELDS.booking,
        requiredAddressFields: constants_1.REQUIRED_PATIENT_ADDRESS_FIELDS.booking
    });
    if (invalidFields.length > 0) {
        const bookingValidationError = {
            message: 'Invalid Patient Error - Booking',
            displayToUser: true,
            type: types_1.ValidationErrorType.INVALID_PATIENT_DATA_BOOKING,
            data: invalidFields
        };
        return Object.assign(Object.assign({}, ctx), { validationErrors: Object.assign(Object.assign({}, ctx.validationErrors), { booking: bookingValidationError }) });
    }
    return ctx;
});
/**
 * an action to set error object  in context for invalid patient fields
 */
exports.setError = (0, xstate_1.assign)({
    errors: (ctx, ev) => {
        (0, util_1.assertEventType)(ev, constants_1.CrmConnectorEvents.ERROR_REQUEST_PATIENT, constants_1.CrmConnectorEvents.ERROR_SEND_REFERRAL_DATA, constants_1.CrmConnectorEvents.ERROR_SEND_BOOKING_DATA, constants_1.CrmConnectorEvents.ERROR_VALIDATE_POST_MESSAGE, constants_1.CrmConnectorEvents.FAIL_MAX_RETRIES, constants_1.CrmConnectorEvents.FAIL_NO_RETRY);
        if (ev.type === constants_1.CrmConnectorEvents.ERROR_REQUEST_PATIENT) {
            return [
                ...ctx.errors,
                {
                    message: 'Request patient failed',
                    displayToUser: true,
                    type: types_1.ErrorType.REQUEST_PATIENT_FAILED
                }
            ];
        }
        if (ev.type === constants_1.CrmConnectorEvents.ERROR_SEND_REFERRAL_DATA) {
            return [
                ...ctx.errors,
                {
                    message: 'Error while sending referral data',
                    displayToUser: true,
                    type: types_1.ErrorType.SENDING_REFERRAL_DATA_ERROR
                }
            ];
        }
        if (ev.type === constants_1.CrmConnectorEvents.ERROR_SEND_BOOKING_DATA) {
            return [
                ...ctx.errors,
                {
                    message: 'Error while sending booking data',
                    displayToUser: true,
                    type: types_1.ErrorType.SENDING_BOOKING_DATA_ERROR
                }
            ];
        }
        if (ev.type === constants_1.CrmConnectorEvents.ERROR_VALIDATE_POST_MESSAGE) {
            return [
                ...ctx.errors,
                {
                    message: 'Invalid postMessage URL',
                    displayToUser: true,
                    type: types_1.ErrorType.INVALID_POST_MESSAGE_URL
                }
            ];
        }
        return [
            ...ctx.errors,
            {
                message: 'No patient data received from the CRM',
                displayToUser: true,
                type: types_1.ErrorType.NO_PATIENT_DATA_RECEIVED
            }
        ];
    }
});
exports.dismissError = (0, xstate_1.assign)({
    errors: (ctx, ev) => {
        (0, util_1.assertEventType)(ev, constants_1.CrmConnectorEvents.DISMISS_ERROR);
        const [, ...restErrors] = ctx.errors;
        return restErrors;
    }
});
exports.captureEnvData = (0, xstate_1.assign)({
    envData: (ctx, ev) => {
        var _a, _b, _c;
        if (ev.type === constants_1.CrmConnectorEvents.UNKNOWN_ORIGIN) {
            return Object.assign(Object.assign({}, ctx.envData), { origin: (_a = ev.data.origin) !== null && _a !== void 0 ? _a : (_b = ctx.envData) === null || _b === void 0 ? void 0 : _b.origin });
        }
        return {
            referrer: (_c = window === null || window === void 0 ? void 0 : window.document) === null || _c === void 0 ? void 0 : _c.referrer,
            postMessageUrl: ctx.postMessageUrl
        };
    }
});
/*
 * Action handlers that can be overridden by the consumer.
 * Each handler executes as part of the specified action.
 * E.g. `onAddReferral` executes when the `addReferral` action is triggered.
 */
exports.onPatientReceived = exports.NOOP;
exports.onAddReferral = exports.NOOP;
exports.onRemoveReferral = exports.NOOP;
exports.onSendBookingData = exports.NOOP;
exports.onSendReferralData = exports.NOOP;
exports.onPostMessageUrlValidated = exports.NOOP;
exports.onRetry = exports.NOOP;
exports.onFailNoRetry = exports.NOOP;
exports.onFailMaxRetries = exports.NOOP;
exports.onInitialization = exports.NOOP;
exports.onInitializationError = exports.NOOP;
//# sourceMappingURL=actions.js.map